import React from 'react';

export default function Footer() {
	return (
		<div>
			<h3>Footer</h3>
		</div>
	);
}
